export enum ContractorInfoLabel {
  ContractorBusinessName = 'Contractor Business Name',
  ContractorCity = 'Contractor City',
  ContractorState = 'Contractor State',
  ContractorFirstName = 'Contractor First Name',
  ContractorPhone = 'Contractor Phone',
}

export enum ContractorInfoField {
  ContractorLocated = 'isContractorLocated',
  ContractorBusinessName = 'contractorBusinessName',
  ContractorCity = 'contractorCity',
  ContractorState = 'contractorState',
  ContractorPhone = 'contractorPhone',
  ContractorFirstName = 'contractorFirstName',
}

export enum ContractorLocatedRadioValue {
  Yes = 'Yes',
  No = 'No',
}
